import React from "react";
import Testimonials from "../home/Testimonials";

const MarketingTestimonials = () => {
  return <Testimonials />;
};

export default MarketingTestimonials;
